const styles = {
  image: {
    width: '100%',
    background: 'linear-gradient(0deg, white, lightgrey)',
  },
};

export default styles;
